import { GlobalService } from "./../../_global/global.service";
import { BehaviorSubject } from "rxjs/Rx";
import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Router, NavigationExtras } from "@angular/router";
import { BaseProvider } from "../BaseProvider";
import {
    UserRequestModel,
    UserResponseModel,
    ForgotPasswordRequest,
    SetPasswordModel,
} from "../../_models/index";
import { Subject } from "rxjs/Subject";
@Injectable()
export class UsersService extends BaseProvider {
    resource = "users";
    forgotresource = "users";
    private notifications: BehaviorSubject<{}> = new BehaviorSubject<{}>({});
    // public notify = new Subject<any>();

    constructor(
        private http: Http,
        private router: Router,
        private _gs: GlobalService
    ) {
        super(http);
    }
    getUsers() {
        // Fetch all users given the token
        return this.makeGetCall(
            this.resource + "?scope=basic&partnerId=" + this._gs.currentUser.partner.id
        );
    }
    getUserId(userId) {
        // Fetch a particular user details given the id
        return this.makeGetCall(this.resource + "/" + userId + "?scope=full");
    }
    getUserByPartnerId(partnerId, scope?) {
        // Fetch a particular user details given the id
        return this.makeGetCall(
            this.resource + "?scope=" + scope + "&partnerId=" + partnerId
        );
    }

    getUserByRRAgentId(partnerId, rrAgent, scope?) {
        // Fetch a particular user details given the id
        return this.makeGetCall(
            this.resource +
            "?scope=" +
            scope +
            "&partnerId=" +
            partnerId +
            "&rrAgent=" +
            rrAgent
        );
    }

    addUser(userRequest: UserRequestModel) {
        // Add an user  given the user details
        return this.makePostCall(this.resource + "?scope=full", userRequest);
    }

    forgotPassword(forgotRequest: ForgotPasswordRequest) {
        // Make Forgot password flow
        return this.makePostCall(
            this.forgotresource + "/current/resetPassword",
            forgotRequest
        );
    }

    setPasswordwithOTP(setPasswordModel: SetPasswordModel) {
        // Set an user password
        return this.makePostCall(
            this.forgotresource + "/current/password",
            setPasswordModel
        );
    }

    updatePasswordwithOTP(setPasswordModel: SetPasswordModel) {
        // Update an user password
        return this.makePatchCall(
            this.forgotresource + "/current/password",
            setPasswordModel
        );
    }

    uploadDocument(uploadRequest: any, userId: string) {
        // Update an user Document
        return this.makeUploadCall(
            this.resource + "/" + userId + "/photo",
            uploadRequest
        );
    }
    uploadDocumentPost(uploadRequest: any, userId: string) {
        // Update an user ProfilePic
        return this.makeUploadCallPost(
            this.resource + "/" + userId + "/photo",
            uploadRequest
        );
    }

    editUser(user) {
        // TODO: to be removed from here
        const navigationExtras: NavigationExtras = {
            queryParams: {
                id: user.id,
            },
        };
        this.router.navigate(["/admin/employees/edit"], navigationExtras);
    }
    updateUser(user, userId) {
        // Update an user  given the updated user details
        return this.makePutCall(this.resource + "/" + userId, user);
    }
    deleteUser(userId) {
        // Delete an user given the user id
        return this.makeDeleteCall(this.resource + "/" + userId);
    }
    updateUserStatus(userId, requestModel: any) {
        // Delete an user given the user id
        return this.makePatchCall(this.resource + "/" + userId, requestModel);
    }

    // public notifyOther(data: any) {
    //   if (data) {
    //     return this.notify.next(data);
    //   }
    // }
    notify(data: string) {
        // Seems to do nothing ?
        this.notifications.next({ data: data });
    }
    notifyObservable$ = this.notifications.asObservable();
}



// WEBPACK FOOTER //
// ./src/app/_services/users/users.service.ts